import PropTypes from 'prop-types';
import ConditionCardGrid from './ConditionCardGrid';
import ConditionCardCarousel from './ConditionCardCarousel';

export function ConditionCardWrapper({ items }) {
  return (
    <section className="pt-5 md:pt-0">
      <ConditionCardGrid items={items} />
      <ConditionCardCarousel items={items} />
    </section>
  );
}

ConditionCardWrapper.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      imageUrl: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired
};
